export const variants = {
  light: "bg-chorus-gray-300 hover:bg-chorus-gray-600",
  dark: "bg-chorus-black-200 hover:bg-chorus-black-100",
};

export const sizes = {
  thin: "w-[6px]",
  fat: "w-[9px]",
};
